import { render, staticRenderFns } from "./activity-table-item.vue?vue&type=template&id=fd3b1aa6&"
import script from "./activity-table-item.vue?vue&type=script&lang=js&"
export * from "./activity-table-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports